<template>
  <div class="map-chart-panel" :style="style" v-resize="onResize">
    <div
      id="mapContainer"
      :style="{ height: height + 'px' }"
      ref="toChart"
    ></div>
    <div
      v-show="!store.series.length"
      :style="{ 'line-height': height + 'px' }"
      class="map-charts-empty"
    >
      暂无数据
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
// import 'echarts/map/js/china.js'
import cityGeoCoord from './geo/cityGeoCoord.json'
import provinceGeoCoord from './geo/provinceGeoCoord.json'
import { util } from '../../utils'
export default {
  name: 'analysisEventChartMapPanel',
  props: {
    height: {
      type: Number,
      default: 700
    },
    queryParam: {
      type: Object,
      default: null
    },
    /**
     * @description 图表数据源
     */
    store: {
      type: Object,
      validator(store) {
        return store && util.isArray(store.series) && util.isArray(store.x_axis)
      }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  computed: {
    style() {
      let style = {
        height: this.height + 'px'
      }
      if (this.width) style.width = `${this.width}px`
      return style
    },
    isCity() {
      let result = false
      if (
        this.queryParam &&
        ['city', 'current_city'].includes(this.queryParam.dimension_sub)
      ) {
        result = true
      }
      return result
    },
    haveUserGroup() {
      let userGroup = this.queryParam ? this.queryParam.user_group : ''
      return util.haveUserGroup(userGroup)
    },
    haveUserGroupCompare() {
      let userGroup = this.queryParam ? this.queryParam.user_group : ''
      if (this.haveUserGroup && userGroup.split(',').length > 1) {
        return true
      }
      return false
    },
    tooltipFormat() {
      return params => {
        if (params.data === null || params.data === undefined) return
        let data = params.data
        if (data.childrenOptions && data.childrenOptions.length) {
          let series = []
          let childrenOptions = data.childrenOptions
          childrenOptions.forEach(option => {
            let label = option.name || option.names.join('-')
            let value = option.value || option.values
            if (util.isArray(value)) {
              value = value[value.length - 1]
            }
            series.push(
              `${label}: <span style="color:#66ccff;">${util.toThousands(
                value
              )}</span>`
            )
          })
          return `${series.join('<br/>')}`
        }
        let dataValue = data.value || data.values
        if (util.isArray(dataValue)) {
          dataValue = dataValue[dataValue.length - 1]
        }
        return `${data.name ||
          data.names.join(
            '-'
          )}: <span style="color:#66ccff;">${util.toThousands(
          dataValue
        )}</span>`
      }
    },
    mapStore() {
      let userGroup = this.queryParam ? this.queryParam.user_group : ''
      let haveUserGroup = util.haveUserGroup(userGroup)
      if (haveUserGroup) {
        // 有用户群时增加userGroupCompareData
        let store = {
          x_axis: this.store.x_axis,
          series: []
        }
        let areaObjMap = {}
        this.store.series.forEach(item => {
          let areaName = item.names[item.names.length - 1]
          if (!areaObjMap[areaName]) {
            areaObjMap[areaName] = {
              names: [areaName],
              values: item.values,
              userGroupCompareData: [item]
            }
          } else {
            // 注：当有用户群对比时，此区域的values粗略计算为各用户群相加之和（此处未去重，因数据不准目前只做颜色展示，后续产品会修改）
            areaObjMap[areaName].values = [
              areaObjMap[areaName].values[0] + item.values[0]
            ]
            areaObjMap[areaName].userGroupCompareData.push(item)
          }
        })
        for (let area in areaObjMap) {
          store.series.push(areaObjMap[area])
        }
        return store
      } else {
        return this.store
      }
    },
    citySeries() {
      let backGroundMapSeries = {
        type: 'map',
        mapType: 'china',
        showLegendSymbol: false,
        top: 20,
        bottom: 20,
        data: [] // 省份着色背景地图数据
      }
      let scatterSeries = {
        name: '',
        type: 'scatter',
        coordinateSystem: 'geo',
        symbolSize: 8,
        data: [] // 城市散点图数据
      }
      let provinceMapData = {}
      this.mapStore.x_axis.forEach((xItem, i) => {
        scatterSeries.name = xItem
        this.mapStore.series.forEach(cityItem => {
          let cityName = cityItem.names[cityItem.names.length - 1]
          let cityCoordObj = cityGeoCoord[cityName.replace(/(省|市)$/, '')] // 城市坐标对象
          if (cityCoordObj) {
            let cityValue = cityItem.values[i]
            let scatterItem = {
              name: cityCoordObj.name,
              isCity: true,
              value: [cityCoordObj.log, cityCoordObj.lat, cityValue],
              childrenOptions: cityItem.userGroupCompareData
            }
            scatterSeries.data.push(scatterItem)
            // 计算省份数据，注有用户群对比时，因无法去重，导致省份数据不准，目前省份数据只做颜色区分，不做数据展示，后续产品方案会修改
            let provinceObj = cityCoordObj.province // 省份坐标对象
                        let provinceName = provinceObj
              ? provinceObj.name.replace(/(省|市)$/, '')
              : ''
            let currentMapData = provinceMapData[provinceName]
            let currentMapOptions = currentMapData
              ? currentMapData.childrenOptions
              : []
            provinceMapData[provinceName] = {
              name: provinceName,
              isProvince: true,
              value: currentMapData
                ? currentMapData.value + cityValue
                : cityValue, // 粗略计算省份数据：城市之和
              childrenOptions: currentMapOptions.concat(
                this.haveUserGroup ? cityItem.userGroupCompareData : [cityItem]
              )
            }
          }
        })
      })
      for (let j in provinceMapData) {
        backGroundMapSeries.data.push({
          itemStyle: {
            color: '#ccccef',
            opacity: 0.5
          },
          ...provinceMapData[j]
        })
      }
      return [scatterSeries, backGroundMapSeries]
    },
    provinceSeries() {
      let series = []
      this.mapStore.x_axis.forEach((xItem, i) => {
        let item = {
          name: xItem,
          type: 'map',
          mapType: 'china',
          roam: false, //是否开启鼠标缩放和平移漫游
          top: 20,
          bottom: 20,
          label: {
            show: true,
            color: '#565656'
          },
          showLegendSymbol: false, // 显示系列标识的小圆点
          data: []
        }
        this.mapStore.series.forEach(provinceItem => {
          let name = provinceItem.name || provinceItem.names
          let provinceName = util.isArray(name) ? name[name.length - 1] : name
          let provinceCoordObj =
            provinceGeoCoord[provinceName.replace(/(省|市)$/, '')]

          if (provinceCoordObj) {
            // 过滤json库中不存在的省
            item.data.push({
              name: (util.isArray(name) ? name.join('-') : name).replace(
                /(省|市)$/,
                ''
              ),
              isProvince: true,
              value: provinceItem.values[i],
              childrenOptions: provinceItem.userGroupCompareData
            })
          }
        })
        series.push(item)
      })
      return series
    },
    option() {
      let option = {
        geo: {
          map: 'china', // 城市散点图的地图坐标
          roam: false,
          top: 20,
          bottom: 20
        },
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 12
          },
          confine: true,
          formatter: this.tooltipFormat
        },
        legend: {
          show: false
        },
        visualMap: {
          type: 'continuous',
          min: this.maxMinValue.min,
          max: this.maxMinValue.max,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          realtime: true,
          calculable: true,
          seriesIndex: 0,
          inRange: {
            color: ['lightskyblue', 'yellow', 'orangered']
          },
          show: !this.haveUserGroupCompare // 用户群对比不支持
        },
        toolbox: {
          show: true,
          orient: 'horizontal',
          right: '20',
          bottom: '20',
          feature: {
            saveAsImage: {
              show: true,
              title: '保存为图片'
            }
          }
        },
        series: this.isCity ? this.citySeries : this.provinceSeries
      }
      return option
    },
    maxMinValue() {
      let max = 100
      let min = 0
      let valueArr = []
      let series = this.isCity ? this.citySeries[0] : this.provinceSeries[0]
      series.data.forEach(item => {
        let value = item.hasOwnProperty('value') ? item.value : item.values
        if (util.isArray(value)) {
          value = value[value.length - 1]
        }
        valueArr = valueArr.concat([value])
      })
      if (valueArr.length) {
        max = Math.max(...valueArr)
        min = Math.min(...valueArr)
      }
      if (max <= min) {
        max = min + 1
      }
      return {
        max: max,
        min: min
      }
    }
  },
  watch: {
    option() {
      this.setOption()
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.toChart)
    this.setOption()
  },
  updated() {
    this.onResize()
  },
  methods: {
    setOption() {
      this.chart.clear()
      this.chart.setOption(util.clone(this.option))
    },
    onResize() {
      if (!this.chart) return
      // 当图表被隐藏时发生resize事件后会导致图表渲染异常，需要延时矫正
      this.chart.resize()
      this.setOption()
      this.$nextTick(() => {
        if (!this.chart) return
        this.chart.resize()
      })
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/constants"
.map-chart-panel
  background: #fff
  width: 100%
  position: relative
  min-height: 400px
  overflow: auto
  .mapContainer, .map-charts-empty
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
  .map-charts-empty
    font-size: 14px
    color: $color-font-content
    text-align: center
    background: #fff
</style>
